const Theme = {
  card_background_color: 'white',
  body_background_color: '#93B25B',

  logo_image_url: 'familizoo.png',
  header_full_height: true,

  number_hidden: true,
  token_hidden: true,

  button_color: '#628D2B',

  text_font: 'Poppins',
  text_color: 'black',

  title_font: 'Raleway',
  subtitle_font: 'Raleway',

  popup_text_color: 'black',

  button_radius: 10,
  button_border_width: 1
}

export default Theme
